export default "__VITE_ASSET__N$85giqu__"